<template>
    <div class="map-outer">
        <div class="indicator" v-if="initializing"><spinner /></div>
        <div class="map-inner" ref="mapContainer"></div>
    </div>
</template>
<script>
import Spinner from "./spinner.vue";

export default {
    components: {
        Spinner,
    },
    props: {
        modelValue: {
            type: Array,
            default() {
                return [];
            },
        },
    },
    data() {
        return {
            map: null,
            markers: [],
            model: this.modelValue,
            loadingMapScript: true,
            initialised: false,
        };
    },
    mounted() {
        const self = this;

        // Use the google maps api key set for the application or the built in qik.dev one as a backup
        const apiKey =
            self.$sdk.app?.global?.googleMapsAPIKey ||
            "AIzaSyDxBa2lg5dUZWvVSAO2EfgHHKuNnERMzec";

        // Ensure the maps are loaded
        self.$sdk.utils
            .loadExternalScript(
                `https://maps.googleapis.com/maps/api/js?key=${apiKey}`,
            )
            .then(
                function (res) {
                    self.loadingMapScript = false;
                },
                function (err) {
                    self.loadingMapScript = false;
                },
            );
    },
    watch: {
        modelValue(m) {
            this.model = m;
            this.redrawMarkers();
        },
        loadingMapScript: { handler: "checkInitialisation", immediate: true },
    },
    beforeUnmount() {
        if (this.map) {
            window.google.maps.event.clearInstanceListeners(this.map);
        }
    },
    methods: {
        checkInitialisation() {
            const self = this;
            if (self.loadingMapScript) {
            } else {
                // Initialize the map
                self.initializeMap();
            }
        },
        focus() {},
        // Deletes all markers in the array by removing references to them.
        deleteMarkers() {
            const self = this;
            for (let i = 0; i < self.markers.length; i++) {
                const { marker, circle } = self.markers[i];
                marker.setMap(null);
                if (circle) {
                    circle.setMap(null);
                }
            }
            self.markers = [];
        },
        redrawMarkers() {
            const self = this;
            self.deleteMarkers();

            self.model.forEach(function (location) {
                const lat = Number(location.latitude || 0);
                const lng = Number(location.longitude || 0);

                if (!lat || !lng) {
                    return;
                }

                const position = new google.maps.LatLng(lat, lng);
                const marker = new window.google.maps.Marker({
                    position,
                    map: self.map,
                });

                let circle;
                if (location.threshold) {
                    // Draw a circle on the map
                    circle = new window.google.maps.Circle({
                        center: position,
                        radius: Number(location.threshold), // Radius in meters
                        strokeColor: "#FF0000",
                        strokeOpacity: 0.8,
                        strokeWeight: 2,
                        fillColor: "#FF0000",
                        fillOpacity: 0.35,
                        map: self.map,
                    });
                }

                self.markers.push({
                    marker,
                    circle,
                });
            });

            self.centralize();
        },
        centralize() {
            const bounds = new google.maps.LatLngBounds();
            this.model.filter(Boolean).forEach((marker) => {
                bounds.extend(
                    new google.maps.LatLng(marker.latitude, marker.longitude),
                );
            });
            this.map.fitBounds(bounds);
        },
        initializeMap() {
            const self = this;
            if (self.initialised) {
                return;
            }

            self.initialised = true;

            // Setup the map
            self.map = new window.google.maps.Map(self.$refs.mapContainer, {
                zoom: 12,
                streetViewControl: false,
            });

            self.redrawMarkers();
        },
    },
};
</script>
<style lang="scss">
.map-outer {
    overflow: hidden;
    height: 0;
    padding-bottom: 56.25%;
    position: relative;
    background: color-mix(in lab, currentColor 10%, transparent);

    .map-inner {
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        top: 0;
    }
    .indicator {
        position: absolute;
        pointer-events: none;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        text-align: center;
        width: 100%;
        z-index: 8;
        font-size: 3em;
    }
}

a {
    cursor: pointer;
}
</style>
